const lang = {
  breadcrumb: {
    management: 'アカウント管理',
    list: 'アカウント一覧',
  },
  steps: {
    search: '検索',
    select_an_account: 'アカウントを選択する',
    checking_content: '内容を確認する',
  },
  search: {
    title: '検索',
    label: {
      name: '氏名',
      name_kana: '氏名（カナ）',
      gender: '性別',
      email: 'メールアドレス',
      phone_number: '携帯電話番号',
      division: '事業部',
      company: '会社名',
      property: '担当物件',
    },
    placeholder: {
      email: 'メールアドレス',
      division: '事業部選択',
      company: '会社名選択',
      property: '担当物件選択',
    },
    button: {
      add_an_account: 'アカウントを追加する',
      all_material: '全てのアカウントを表示する',
      search: '検索する',
    },
  },
  list: {
    current_search_criteria: '現在の検索条件',
    label: {
      belongs: '所属',
      gender: '性別',
      email: 'メールアドレス',
      phone_number: '携帯電話番号',
    },
    paginate_text:
      '<span class="flex items-center">アカウント一覧<span class="text-sm ml-8">(全 {total} 件中 {from} 件 〜 {to} 件を表示)</span></span>',
    button: {
      search: '検索条件変更',
    },
    belongs_to: '自社 {division}',
    none: 'なし',
  },
  create: {
    page_title: 'アカウント作成',
    page_title_confirm: 'アカウント作成<span class="text-base">（確認）</span>',
    button: {
      change_image: '変更する',
      confirm_input: '入力を確認する',
      save: '保存する',
      return_to_input: '入力に戻る',
      create: '作成する',
    },
    placeholder: {
      email: 'メールアドレス',
      division: '事業部選択',
      company: '会社名選択',
      property: '担当物件選択',
      password: '新しいパスワードを入力',
      password_confirm: '新しいパスワードを再度入力',
    },
    label: {
      id: 'ID',
      email: 'メールアドレス',
      belongs: '所属',
      for_our_company: '【自社所属の場合】',
      division: '事業部',
      for_other: '【自社以外の所属の場合】',
      company: '会社名',
      property: '担当物件（複数選択可）',
      name: '氏名',
      name_kana: '氏名（カナ）',
      gender: '性別',
      phone_number: '携帯電話番号',
      icon: 'アイコン',
      password: 'パスワード',
      password_confirm: 'パスワード確認',
      expert_mode: 'エキスパートモード',
      account_manageable: 'アカウント管理権限',
    },
    belongs_to_note: '所属に合わせて入力してください。',
    message_confirm_create:
      '作成するアカウントのメールアドレスにアカウント登録のご案内をお送りします。<br />よろしければ「作成する」を押してください。',
  },
  edit: {
    page_title: 'アカウント編集',
    page_title_confirm: 'アカウント編集<span class="text-base">（確認）</span>',
    button: {
      delete: '削除する',
      cancel_delete: 'キャンセル',
      confirm_delete: '削除する',
    },
    message: {
      confirm_delete: '削除する場合「削除する」をクリックして下さい。',
    },
  },
  create_password: {
    title: 'アカウントパスワード設定',
    placeholder: {
      email: 'ご自身のメールアドレス',
      password: '新しいパスワードを入力',
      confirm_password: '新しいパスワードを再度入力',
    },
    button: {
      sign_up: '登録する',
      go_to_login: 'ログイン画面に移動する',
    },
    message_complete: 'アカウントのパスワード設定が完了しました。<br>ログイン画面からログインを行ってください。',
  },
}

export default lang
